import { useTranslation } from 'next-i18next';

import { useMemo } from 'react';

import { formatHelpers } from '@nocowanie/core/helpers';

import { CautionMoneyType } from '@app/models/elastic-search';
import * as accommodationStaticSlice from '@app/state/slices/accommodation-static.slice';
import { useAppSelector } from '@app/state/state';

export const DepositInformation = () => {
    const { t } = useTranslation('accommodation', { keyPrefix: 'stayRules.deposit' });

    const cautionMoney = useAppSelector(
        accommodationStaticSlice.selectors.selectCautionMoneyPolicy,
    );
    const currency = useAppSelector(accommodationStaticSlice.selectors.selectCurrency);

    const depositInfo = useMemo(() => {
        if (!cautionMoney || cautionMoney.amount === 0) {
            return t('noDepositFee');
        }

        let amountText = '';

        switch (cautionMoney.type) {
            case CautionMoneyType.FixedAmount:
                amountText = formatHelpers.price(cautionMoney.amount, currency);
                break;
            case CautionMoneyType.PerPersonPerNight:
                amountText = t('perPersonPerNight', {
                    value: formatHelpers.price(cautionMoney.amount, currency),
                });
                break;
            case CautionMoneyType.PercentOfReservation:
                amountText = t('percentOfReservation', {
                    value: cautionMoney.amount,
                });
                break;
        }

        return `${amountText} ${t('refundInfo')}`;
    }, [cautionMoney, currency, t]);

    return <>{depositInfo}</>;
};
